@if (product(); as product) {
  <div class="relative">
    @if (isProductStepperStable() === 'unstable' || isProductStepperStable() === 'earlyAddToCart') {
      <div class="absolute inset-0 z-0">
        <div class="flex h-[75vh] flex-col items-center justify-center gap-24">
          @if (isProductStepperStable() === 'earlyAddToCart') {
            <p class="text-4xl">
              {{ 'kiosk-product-add-page.auto-added-to-cart-product' | translate }}
            </p>
            <p class="text-8xl font-bold">{{ product.name }}</p>
            @if (product.images?.thumbnail?.url) {
              <img
                [src]="product.images?.thumbnail?.url"
                [alt]="product.name"
                class="max-w-full"
              />
            } @else {
              <i class="icon icon-add-to-cart-2 animate-bounce text-8xl"></i>
            }
          }
        </div>
      </div>
    }

    <div
      class="relative block h-full overflow-hidden"
      [class.invisible]="isProductStepperStable() !== 'stable'"
    >
      <div
        class="flex h-full flex-col gap-5"
        [style.color]="textColor() | contentBuilderColor"
      >
        <app-kiosk-product-details-block
          (addToCart)="addToCart$.next($event)"
          (selectedStep)="selectedStep$.next($event)"
          (backRequest)="onBackRequest()"
          [config]="{
            'card_color': cardColor(),
            'primary_button_background_color': buttonBackgroundColor(),
            'primary_button_text_color': buttonTextColor(),
            'unavailable_button_background': unavailableButtonBackground(),
            'unavailable_button_text': unavailableButtonText(),
            'composition_background_color': compositionBackgroundColor(),
            'text_color': textColor(),
            'background_color': backgroundColor(),
            'background_image': backgroundImage(),
            'secondary_color': secondaryColor(),
            'composition_product_id': productId(),
          }"
        >
        </app-kiosk-product-details-block>
      </div>
    </div>
  </div>
}
